export default "__VITE_PUBLIC_ASSET__56567ed9__"